import { TabsProps as AntdTabsProps } from 'antd';
import classNames from 'classnames';
import { StyledTabs } from './Tabs.styles';

export const Tabs = ({ className, ...props }: AntdTabsProps): JSX.Element => {
  const tabsClassName = classNames(className, 'tabs');

  return <StyledTabs className={tabsClassName} {...props}></StyledTabs>;
};
